import React, { useCallback } from "react";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { message, Modal } from "antd";
import { connect } from "dva";
import { ShipmentStatus } from "@/utils/enum";
import { hideJiraWidget } from "@/utils/utils";
import { deleteVehicle } from "@/services/vehicles";
import MoreMenu from "@/components/MoreMenu";

const { confirm } = Modal;

const VehicleMenu = ({ dispatch, shipmentData, vehicleData, vehicleAndLoadData }) => {
  const handleDeleteVehicleFromShipment = vehicleId => {
    confirm({
      title: "Delete Vehicle",
      content: "Are you sure you want to delete this vehicle?",
      onOk() {
        const hide = message.loading("Deleting vehicle...");
        deleteVehicle(vehicleId).then(res => {
          if (!res) {
            message.error("Could not delete vehicle.");
          } else {
            const updatedVehicles = shipmentData.vehicles.filter(x => x.id !== vehicleId);
            dispatch({
              type: "shipmentDetails/setEditVehicle",
              vehicles: updatedVehicles,
            });
            message.success("Successfully deleted vehicle.");
          }
          hide();
        });
      },
    });
  };

  const onItemClick = useCallback(
    key => {
      switch (key) {
        case "edit":
          dispatch({
            type: "shipmentDetails/setEditVehicleData",
            // adding load data into edit payload data to check for some field edit permissions
            payload: {
              ...vehicleData,
              load: vehicleAndLoadData?.load,
            },
          });
          hideJiraWidget();
          break;
        case "delete":
          handleDeleteVehicleFromShipment(vehicleData.id);
          break;
        case "transfer":
          dispatch({
            type: "shipmentDetails/setTransferVehicleId",
            payload: vehicleData.vehicle.id,
          });
      }
    },
    [shipmentData, vehicleData, handleDeleteVehicleFromShipment],
  );

  return (
    <div style={{ display: "flex", flexDirection: "row-reverse" }}>
      {shipmentData.status < ShipmentStatus.Assigned && (
        <MoreMenu
          onItemClick={onItemClick}
          items={[
            {
              key: "edit",
              icon: <EditOutlined />,
              label: "Edit",
              authority: ["CoreService.Shipments.Vehicles.Edit"],
            },
            {
              key: "delete",
              icon: <DeleteOutlined />,
              label: "Delete",
              authority: ["CoreService.Shipments.Vehicles.Delete"],
            },
          ]}
        />
      )}
    </div>
  );
};

export default connect(({ configs, user, shipmentDetails }) => ({
  configPerm: configs.configPerm,
  connectionRoleTypes: user.connectionRoleTypes,
  vehicleAndLoadData: shipmentDetails.vehicleAndLoadData[0],
}))(VehicleMenu);
